import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Row, Col } from 'reactstrap';

import { callApi, formatDate, formatAmount } from '../utils';
import { showError } from '../actions/notificationActions';

import DataTable, { PageHeader } from './DataTable';
import SuccessTick from './SuccessTick';
import ErrorTick from './ErrorTick';
import SearchForm from './SearchForm';
import { openTransactionModal } from '../actions/modalActions';

class AllPayments extends Component {
  state = {
    query: '',
    transactions: [],
    paymentType: '',
    page: 1,
    limit: 15,
    loading: false,
  };

  componentWillMount() {
    this.loadTransactions();
  }

  startLoad = () => this.setState({ loading: true });
  stopLoad = () => this.setState({ loading: false });

  scrollToTop = () =>
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);

  loadTransactions = (e) => {
    // Event may be passed in from search form
    if (e) e.preventDefault();

    const { query, paymentType, page, limit } = this.state;
    this.startLoad();
    callApi(
      `/transactions/payments?q=${query}&paymentType=${paymentType}&page=${page}&limit=${limit}`
    )
      .then(({ transactions = [] }) => {
        this.setState({ loading: false, transactions });
        this.scrollToTop();
      })
      .catch((err) => {
        this.stopLoad();
        this.props.dispatch(showError(err));
      });
  };

  setPage = (page) => {
    if (page) {
      this.setState({ page }, () => {
        this.loadTransactions();
      });
    }
  };

  setQuery = (e) => {
    this.setState({ query: e.target.value });
  };

  openTransaction = (t) => {
    this.props.dispatch(openTransactionModal(t));
  };

  render() {
    const { query, transactions, page, loading, limit } = this.state;
    const hasResults = transactions.length > 0;
    return (
      <div className="container-fluid">
        <Row className="mt-3 mt-md-4">
          <Col xs={12}>
            <PageHeader
              title="ALL PAYMENTS"
              subtitle={'All payment attempts — page ' + page}
            >
              <SearchForm
                value={query}
                onChange={this.setQuery}
                onSearch={this.loadTransactions}
                loading={loading}
              />
            </PageHeader>

            <DataTable
              minWidth={1000}
              loading={loading}
              page={page}
              onPageChange={this.setPage}
              showPagination={hasResults}
            >
              <thead className="text-primary">
                <tr>
                  <th>No.</th>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Meter</th>
                  <th>Amount</th>
                  <th>DisCo</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Vend Status</th>
                  <th>Channel</th>
                  <th>Treated</th>
                </tr>
              </thead>

              <tbody>
                {transactions.map((t, i) => (
                  <tr onClick={() => this.openTransaction(t)} key={t.id}>
                    <td>{loading ? '—' : i + 1 + (page - 1) * limit}</td>
                    <td>{formatDate(t.created_at)}</td>
                    <td>{t.name}</td>
                    <td>{t.phone}</td>
                    <td>{t.meter_no}</td>
                    <td>{formatAmount(t.amount)}</td>
                    <td>{t.disco_code}</td>
                    <td>{t.vend_type}</td>
                    <td>{t.payment_status}</td>
                    <td>{t.vend_status}</td>
                    <td>{t.channel}</td>
                    <td className="text-center">
                      {t.treated_on ? <SuccessTick /> : <ErrorTick />}
                    </td>
                  </tr>
                ))}
              </tbody>
            </DataTable>
          </Col>
        </Row>
      </div>
    );
  }
}

export default connect()(AllPayments);
